/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as o from "react";
import n from "prop-types";
import { classNames as a } from "@progress/kendo-react-common";
const s = "ActionSheetContent", t = (e) => /* @__PURE__ */ o.createElement(
  "div",
  {
    className: a(
      "k-actionsheet-content",
      { "!k-overflow-hidden": e.overflowHidden },
      e.className
    )
  },
  e.children
);
t.propTypes = {
  className: n.string
};
t.displayName = s;
t.propTypes = {
  children: n.any
};
export {
  t as ActionSheetContent,
  s as contentDisplayName
};
